module.exports = __webpack_public_path__ + "static/media/congrats.293422aa.gif";